(() => {
  if (window.monolithCountrySearchReady) return;
  window.monolithCountrySearchReady = true;
  let counter = 0;
  const normalize = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const compact = value => normalize(value).replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
  const regions = 'DE AT FR PL VA ES IS IT RO BG BE NL MC GR CY SE MT FI IE HR HU DK LU PT SI SK CZ LV EE LT GB BA AL MK AD GI NO UA CH LI AU NZ SA AE SG CN JP IN KR TH MY LK TW US CA AR BO CK CR CW DM DO EC SV FK FJ GL GP GT HT HN JM CO MQ MS PA PY PE UY VE BJ CV MG MR MU SC AM BD BT BN GE KH LA MN MM NP MO VN BS BB BZ BM GD MF'.split(' ');
  const names = [];
  for (const locale of [document.documentElement.lang, 'de', 'en']) {
    try { names.push(new Intl.DisplayNames([locale], {type:'region'})); } catch {}
  }
  const initialize = () => {
    const template = document.getElementById('monolith-country-search-template');
    if (!template) return;
    document.querySelectorAll('.monolith-shipping:not([data-country-search])').forEach(section => {
      const cards = Array.from(section.querySelectorAll('.monolith-shipping__card'));
      if (!cards.length) return;
      section.dataset.countrySearch = 'true';
      const ui = template.content.firstElementChild.cloneNode(true);
      const input = ui.querySelector('input'), label = ui.querySelector('label');
      input.id = 'monolith-country-search-' + (++counter);
      label.htmlFor = input.id;
      const status = ui.querySelector('.mcs__status'), clear = ui.querySelector('button');
      const index = cards.map(card => {
        const badge = card.querySelector('.monolith-shipping__badge')?.textContent || '';
        const heading = card.querySelector('h3')?.textContent || '';
        const extra = /\d|EU/i.test(badge) ? card.querySelector('p')?.textContent || '' : '';
        let text = normalize([badge, heading, extra].join(' '));
        const aliases = [];
        for (const code of regions) {
          const labels = names.map(display => normalize(display.of(code)));
          if (labels.some(name => (' ' + text + ' ').includes(' ' + name + ' '))) {
            aliases.push(code, ...labels);
            if (code === 'GB') aliases.push('UK', 'England', 'Great Britain', 'Grossbritannien');
            if (code === 'US') aliases.push('USA', 'United States', 'Amerika');
          }
        }
        return compact(text + ' ' + aliases.join(' '));
      });
      const update = () => {
        const query = compact(input.value);
        let count = 0;
        cards.forEach((card, i) => {
          const matches = !query || query.split(' ').every(part => index[i].includes(part));
          card.hidden = !matches;
          if (matches) count++;
        });
        section.querySelectorAll('.monolith-shipping__grid').forEach(grid => {
          grid.hidden = !Array.from(grid.querySelectorAll('.monolith-shipping__card')).some(card => !card.hidden);
        });
        section.querySelectorAll('.monolith-shipping__section').forEach(group => {
          group.hidden = !Array.from(group.querySelectorAll('.monolith-shipping__card')).some(card => !card.hidden);
        });
        clear.hidden = !query;
        status.hidden = !query;
        status.textContent = count ? status.dataset.count.replace('__COUNT__', count) : status.dataset.empty;
      };
      input.addEventListener('input', update);
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') event.preventDefault();
        if (event.key === 'Escape') { event.preventDefault(); input.value = ''; update(); }
      });
      clear.addEventListener('click', () => { input.value = ''; update(); input.focus(); });
      const intro = section.querySelector('.monolith-shipping__intro');
      if (intro) intro.after(ui); else section.prepend(ui);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();